import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { VerifierSourceEntity } from 'src/typings/api-models.generated';
import { OverlayTriggerWrapper } from 'src/ui/shared/components/bootstrap/overlay/OverlayTriggerWrapper';
import { BsIcon } from 'src/ui/shared/components/icon/bs-icon.models';
import { Icon } from 'src/ui/shared/components/icon/Icon';

interface Props {
    item: VerifierSourceEntity | undefined;
    onClick?: (item: VerifierSourceEntity) => void;
}

type ValidType = 'event' | 'activity' | 'unknown';

export const SourceItemName = ({ item, onClick }: Props): React.ReactElement => {
    const type: ValidType = useMemo(() => {
        const lowercase = item?.type.toLowerCase();
        switch (lowercase) {
            case 'event':
            case 'activity':
                return lowercase;
            default:
                return 'unknown';
        }
    }, [item?.type]);

    const icon = useMemo((): BsIcon => {
        switch (type) {
            case 'event':
                return 'ticket';
            case 'activity':
                return 'person-walking';
            default:
                return 'ban';
        }
    }, [type]);

    const title = useMemo(() => {
        return item?.title || 'No title';
    }, [item?.title]);

    if (type === 'unknown') {
        return (
            <OverlayTriggerWrapper
                placement="bottom"
                id="verification-source-item"
                tooltip={<>Unable to retrieve information about this item.</>}
            >
                <span>
                    <Icon icon={icon}>Unknown source</Icon>
                </span>
            </OverlayTriggerWrapper>
        );
    }

    if (!onClick) {
        return <Icon icon={icon}>{title}</Icon>;
    }

    return (
        <Button variant="link" className="p-0" onClick={item ? () => onClick(item) : undefined}>
            <Icon icon={icon}>{title}</Icon>
        </Button>
    );
};
